/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Rows3, Flame, ShieldCheck, Wind, Droplet, Hammer, BadgeCheck } from "lucide-react";

import ProductDetailPage, {
	type ProductDetailConfig,
} from "./ProductDetailPage";

/** Pressed Steel Radiators — marketed as the ONAN transformer cooling range. */
const ONAN: ProductDetailConfig = {
	i18nKey: "onan",
	path: "/products/onan",
	heroBackground: "/images/header/powergeneration.jpg",
	images: ["/images/finalProducts/ONAN.png"],
	highlightKeys: ["fluteGeometry", "weldIntegrity", "corrosionProtection"],
	highlightIcons: [Rows3, Flame, ShieldCheck],
	specKeys: [
		"coolingMode",
		"fluidCompatibility",
		"materialAssembly",
		"qualityTesting",
	],
	specIcons: [Wind, Droplet, Hammer, BadgeCheck],
	wordmark: "ONAN",
	compliancePill: "IEC · IS · IEEE",
	captionEyebrow: "Transformer Cooling",
	captionTitle: "Pressed Steel Radiator",
	specsFooterLabel: "Positron Engineering · Pressed Steel Radiator Series",
};

export default function Onan() {
	return <ProductDetailPage config={ONAN} />;
}
